import { render, staticRenderFns } from "./stadium.vue?vue&type=template&id=5a2c978f&"
import script from "./stadium.vue?vue&type=script&lang=ts&"
export * from "./stadium.vue?vue&type=script&lang=ts&"
import style0 from "./stadium.vue?vue&type=style&index=0&id=5a2c978f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports